module.exports = __webpack_public_path__ + "assets/img/2011591928118_.pic_hd.dcecb931.jpg";